import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import EnumFieldDetail from "./detail";
import EnumFieldEdit from "./edit";
import EnumFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type enum en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Enum() {
    return _jsx(_Fragment, { children: "Enum" });
}
var field = fieldsType.enum;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, EnumFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, EnumFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, EnumFieldList);
